function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from "react";
import FilterDropdown from "./FilterDropdown";
import { templatesFilterDropdown } from "./constants";
import SearchIcon from "../../assets/images/general_icons/search.svg";
import Button from "../../core/components/Button";
var AssignmentTemplateFilters = function AssignmentTemplateFilters(_ref) {
  var onFilter = _ref.onFilter,
    baseQuery = _ref.baseQuery;
  var _useState = useState(baseQuery),
    _useState2 = _slicedToArray(_useState, 2),
    query = _useState2[0],
    setQuery = _useState2[1];
  var _useState3 = useState(baseQuery.search || ''),
    _useState4 = _slicedToArray(_useState3, 2),
    searchValue = _useState4[0],
    setSearchValue = _useState4[1];
  var map = {
    'All Templates': '',
    'School Templates': 'org',
    'My Templates': 'private',
    'Nurture Spaces': 'public'
  };
  var handleTemplateVisibiltyChanged = function handleTemplateVisibiltyChanged(visibility) {
    var newState = _objectSpread(_objectSpread({}, query), {}, {
      visibility: visibility
    });
    setQuery(newState);
    onFilter(newState);
  };
  var handleTemplateSearchChanged = function handleTemplateSearchChanged(event) {
    if (event.type === 'keypress' && event.key === 'Enter' || event.type === 'blur') {
      var newState = _objectSpread(_objectSpread({}, query), {}, {
        search: event.target.value
      });
      setQuery(newState);
      onFilter(newState);
    }
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "mx-0 px-0 mb-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ps-0 mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-wrap"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "me-2",
    onClick: function onClick() {
      return handleTemplateVisibiltyChanged('');
    },
    color: "".concat(!query.visibility ? 'dark' : 'white')
  }, "All Templates"), /*#__PURE__*/React.createElement(Button, {
    className: "me-2",
    onClick: function onClick() {
      return handleTemplateVisibiltyChanged('private');
    },
    color: "".concat(query.visibility === 'private' ? 'dark' : 'white')
  }, "My Templates"), /*#__PURE__*/React.createElement(Button, {
    className: "me-2",
    onClick: function onClick() {
      return handleTemplateVisibiltyChanged('org');
    },
    color: "".concat(query.visibility === 'org' ? 'dark' : 'white')
  }, "School Templates"), /*#__PURE__*/React.createElement(Button, {
    className: "me-2",
    onClick: function onClick() {
      return handleTemplateVisibiltyChanged('public');
    },
    color: "".concat(query.visibility === 'public' ? 'dark' : 'white')
  }, "Nurture Spaces"))), /*#__PURE__*/React.createElement("div", {
    className: "ps-0 ps-md-2 mb-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "input-group"
  }, /*#__PURE__*/React.createElement("img", {
    src: SearchIcon,
    className: "input-group-text border-right-none"
  }), /*#__PURE__*/React.createElement("input", {
    type: "text",
    className: "form-control search search-filter border-left-none",
    placeholder: "Search templates by name or code",
    "aria-label": "template",
    "aria-describedby": "basic-addon1",
    value: searchValue,
    onKeyPress: handleTemplateSearchChanged,
    onBlur: handleTemplateSearchChanged,
    onChange: function onChange(e) {
      return setSearchValue(e.target.value);
    }
  })))));
};
export default AssignmentTemplateFilters;